import { IssueData } from 'zod';
import { validateEpochCastTypeValue } from './validateEpochCastTypeValue';
import { CastType, AnyComparator, FieldType } from '../../../types';
import { validateMergeParamCastTypeValue } from './validateMergeParamCastTypeValue';
import { validateNonCastTypeNumberValue } from './validateNonCastTypeNumberValue';

/**
 * Util to validate the number value for a condition.
 * Checks if the castType is a merge param and has a string value with handlebars (ie: {{ageField}} ).
 * It's also checks for a stringified number if castType is undefined.
 */
export const validateNumberValue = (
  {
    value,
    values,
    fieldType,
    castType,
    comparatorType,
  }: Partial<{
    value: string;
    values: string[];
    fieldType: FieldType;
    castType: CastType;
    comparatorType: AnyComparator;
  }>,
  addIssue: (arg: IssueData) => void,
) => {
  if (fieldType !== FieldType.INTEGER) return;
  validateEpochCastTypeValue({ value, castType }, addIssue);
  validateMergeParamCastTypeValue({ value, castType }, addIssue);
  validateNonCastTypeNumberValue({ value, values, comparatorType, castType }, addIssue);
};
